import {useEffect, useState} from 'react';
import getBrowserFingerprint from 'get-browser-fingerprint';

export default () => {
    const [fingerprint, setFingerprint] = useState(null);

    useEffect(() => {
        getBrowserFingerprint({
            hardwareOnly: false
        }).then(res => {
            setFingerprint(res)
            window.alert(res);
        }).catch(e => {
            window.alert(`No fp`);
        });
    }, [fingerprint]);

    return <></>;
}